import {
  GET_MATCH_CARD_ODDS_REQUEST,
  GET_MATCH_CARD_ODDS_SUCCESS,
  GET_MATCH_CARD_ODDS_FAILURE,
  MATCH_CARD_ODDS_WS_UPDATE,
  RESET_MATCH_CARD,
  MATCH_CARD_EVENT_REMOVED,
  GET_PERSONAL_MARKET_IDS_SUCCESS,
  GET_POPULAR_MARKET_IDS_SUCCESS,
} from 'Store/constants';

import {
  MATCH_CARD_PERSONAL_BETS_TAB_ID, MATCH_CARD_POPULAR_BETS_TAB_ID, DUELLO
} from 'Store/constants/sportTypes';


import EnvironmentManager from 'Utils/environmentManager';

const initialState = {
  data: {},
  isLoading: false,
  isFetched: false,
  error: null,
  personalIdsFetched: false,
  popularIdsFetched: false,
};

const addPopularAndPersonalTabs = oddGroupTabs => {
  if (!Array.isArray(oddGroupTabs)) return [];

  const matchCardPersonalTitle =  EnvironmentManager.getMessageText({ key: 'title_match_card_personal' }) || 'Sana Özel';
  const matchCardPersonalOrder =  Number(EnvironmentManager.getMessageText({ key: 'order_match_card_tabs_personal' })) || 15;
  const matchCardPopularTitle =  EnvironmentManager.getMessageText({ key: 'title_match_card_populer' }) || 'En Populer';
  const matchCardPopularOrder =  Number(EnvironmentManager.getMessageText({ key: 'order_match_card_tabs_popular' }) ) || 17;
  const personalTabVisible =  EnvironmentManager.getMessageText({ key: 'match_card_personal_visible' }) == 'true';
  const populerTabVisible =  EnvironmentManager.getMessageText({ key: 'match_card_popular_visible' }) == 'true';

  const selectedMatchCardId = EnvironmentManager.getMessageText({ key: 'match_card_tab_selected' });

  if (oddGroupTabs.length > 0) {
    if (personalTabVisible) {
      oddGroupTabs.push({
        active: true,
        matchCardOdds: [],
        selected: MATCH_CARD_PERSONAL_BETS_TAB_ID == selectedMatchCardId,
        title: matchCardPersonalTitle,
        order: matchCardPersonalOrder,
        id: MATCH_CARD_PERSONAL_BETS_TAB_ID,
      });
    }
    
    if (populerTabVisible) {
      oddGroupTabs.push({
        active: true,
        matchCardOdds: [],
        selected: MATCH_CARD_POPULAR_BETS_TAB_ID == selectedMatchCardId,
        title: matchCardPopularTitle,
        order: matchCardPopularOrder,
        id: MATCH_CARD_POPULAR_BETS_TAB_ID
      });
    }
  }

  return oddGroupTabs.sort((a, b) => a.order - b.order);
};

const addMatchCardOdds = (oddGroupTabs, marketList = [], title) => {
  const allMatchCardOdds = (oddGroupTabs || []).find(oddGroupTab => oddGroupTab.title === 'Tümü')?.matchCardOdds || [];
  
  if (allMatchCardOdds.length > 0) {
    
    let _matchCardOdds = marketList.map(market => {
      const marketInAllMatchCardOdds = allMatchCardOdds.find(matchCardOdd =>  market?.marketSubType == matchCardOdd.marketSubType
        && market?.marketType == matchCardOdd.marketType && ((matchCardOdd?.oddList || [])).some(odd => (odd.mrId === market.marketId)));
      
      if (marketInAllMatchCardOdds) {
        const _marketInAllMatchCardOdds = { ...marketInAllMatchCardOdds };

        return {
          ..._marketInAllMatchCardOdds,
          ...market,
        };
      }
      return null;

    });
    
          
    const oddGroupTabIdx = oddGroupTabs.findIndex(oddGroupTab => oddGroupTab.title == title);

    _matchCardOdds = (_matchCardOdds || []).filter(market => market);

    const uniqueMatchCardOdds = [...new Map(_matchCardOdds.map(item =>
      [item['name'], item])).values()];

    if (oddGroupTabIdx != -1) {
      oddGroupTabs[oddGroupTabIdx].matchCardOdds =  uniqueMatchCardOdds || [];
    }
  
  }
  return oddGroupTabs;
        
};


export default (state = initialState, action) => {
  const matchCardPopularTitle =  EnvironmentManager.getMessageText({ key: 'title_match_card_populer' }) || 'Popüler (Vaix)';
  const matchCardPersonalTitle =  EnvironmentManager.getMessageText({ key: 'title_match_card_personal' }) || 'Sana Özel';
      
  switch (action.type) {
    case GET_MATCH_CARD_ODDS_REQUEST:
      return { ...state, isLoading: true, isFetched: false, error: null };
    case GET_MATCH_CARD_ODDS_SUCCESS: {
      const canAddPopularAndPersonalTabs = action.payload.sportType !== DUELLO;
      const oddGroupTabs = action.payload.data?.oddGroupTabs || [];
      return { ...state, data: { ...action.payload.data, personalMarkets: [], popularMarkets: [], oddGroupTabs: canAddPopularAndPersonalTabs ? addPopularAndPersonalTabs(oddGroupTabs) : oddGroupTabs }, isLoading: false, isFetched: true, error: null };
      
    }
    case GET_MATCH_CARD_ODDS_FAILURE:
      return { ...state, isLoading: false, isFetched: true, error: action.payload };
    case GET_PERSONAL_MARKET_IDS_SUCCESS: {
      const matchCardPersonalTitle =  EnvironmentManager.getMessageText({ key: 'title_match_card_personal' }) || 'Sana Özel';
      return {  ...state, data: { ...state.data, personalMarkets: action.payload, oddGroupTabs: addMatchCardOdds(state.data.oddGroupTabs, action.payload, matchCardPersonalTitle)
      }, isLoading: false, isFetched: true, error: null, personalIdsFetched: true, };
    }
    case GET_POPULAR_MARKET_IDS_SUCCESS: {
      return {  ...state, data: { ...state.data, popularMarkets: action.payload, oddGroupTabs: addMatchCardOdds(state.data.oddGroupTabs, action.payload, matchCardPopularTitle)
      }, isLoading: false, isFetched: true, error: null, popularIdsFetched: true, };
    }

    case MATCH_CARD_ODDS_WS_UPDATE:
    {
      const { newOdds } = action.payload;
      if ((newOdds?.oddGroupTabs || []).some(oddGroupTab => oddGroupTab.id == MATCH_CARD_PERSONAL_BETS_TAB_ID)) {
        //add personal group tabs
        newOdds.oddGroupTabs = addMatchCardOdds(newOdds.oddGroupTabs || [], newOdds?.personalMarkets || [], matchCardPersonalTitle);
      }
      //add popular group tabs
      if ((newOdds?.oddGroupTabs || []).some(oddGroupTab => oddGroupTab.id == MATCH_CARD_POPULAR_BETS_TAB_ID)) {
        newOdds.oddGroupTabs = addMatchCardOdds(newOdds.oddGroupTabs || [], newOdds?.popularMarkets || [], matchCardPopularTitle);
      }

      return {
        ...state,
        data: { ...newOdds }
      };
    }

    case MATCH_CARD_EVENT_REMOVED: {
      return {
        ...state,
        data: {
          ...state.data,
          oddGroupTabs: (state.data.oddGroupTabs || []).map(oddGroup => ({
            ...oddGroup,
            matchCardOdds: []
          }))
        }
      };
    }

    case RESET_MATCH_CARD:
      return { ...initialState };

    default:
      return state;
  }
};
